<template>
  <div class="w-full flex items-center justify-center">
    <div class="flex h-full">
      <value-or-variable v-model='value.y' type="number" :variables='[]'>
        <template #default='{}'>
          <numberer v-model='angle' @change="onInput" :step="45" />
        </template>
      </value-or-variable>
    </div>
  </div>
</template>
<script>
import Numberer from '@ui/atoms/Numberer.vue';
export default {
  props:{
    value:{
      type:Number,
      required:true
    }
  },
  methods: {
    radiansToDegrees(rad) {
      return rad * (360/(2*Math.PI));
    },
    degreesToRadians(degs) {
      return degs / (360/(2*Math.PI));
    },
    onInput(nv, ov) {
      this.$emit("change", this.degreesToRadians(nv), this.degreesToRadians(ov));
    }
  },
  data() {
    return {
    }
  },
  components:{
    Numberer
  },
  computed:{
    angle: {
      get() {
        return this.radiansToDegrees(this.value);
      },
      set(nv) {
        const nnv = nv < 0 ? (360 + nv) : nv;
        console.log('nnv', nnv);
        this.$emit("input", this.degreesToRadians(nnv % 360));
      }
    }
  }
}
</script>
